"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvType = exports.HttpMethod = void 0;
/**
 * http base interface
 */
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
    HttpMethod["PATCH"] = "PATCH";
    HttpMethod["OPTIONS"] = "OPTIONS";
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["HEAD"] = "HEAD";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
var EnvType;
(function (EnvType) {
    EnvType["ALPHA"] = "ALPHA";
    EnvType["PROD"] = "PROD";
})(EnvType = exports.EnvType || (exports.EnvType = {}));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/shared-base/dist/http/interface.js
// module id = TKAL
// module chunks = 1